<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    if (to.name == "testResult" || to.name == "index") {
      if (to.name == "index") {
        this.$store.commit("setStoreData", {
          name: "testData",
          data: []
        });
        sessionStorage.removeItem("sl");
      }
      next();
    } else {
      next("/index");
    }
  }
};
</script>